// Ghi đè số lẻ theo THỊ TRƯỜNG — phải khớp bảng cùng tên trong ante-nodejs-kit
// và currency_digit trong ante-backend/src/config/data/CountryDefaults/*.json.
//
// Một số nước niêm yết không dùng phần lẻ dù chuẩn quốc tế có. Ghi đè CHỈ áp cho đồng tiền
// mặc định của nước đó, nên doanh nghiệp Campuchia ghi sổ bằng đô la vẫn giữ 2 số lẻ.
//
// Không có bảng này thì màn hình hiện 2 số lẻ trong khi máy chủ tính 0 — người dùng thấy
// một đằng, hệ thống ghi một nẻo.
export const MARKET_DIGIT_OVERRIDES = {
    'ID|IDR': 0,
    'KH|KHR': 0,
    'LA|LAK': 0,
    'MM|MMK': 0,
    'TW|TWD': 0
};

export function applyMarketOverride(isoDigit, code, countryCode) {
    if (!code || !countryCode) return isoDigit;
    const key = String(countryCode).toUpperCase() + '|' + String(code).toUpperCase();
    const d = MARKET_DIGIT_OVERRIDES[key];
    return d === undefined ? isoDigit : d;
}

export default { MARKET_DIGIT_OVERRIDES, applyMarketOverride };
